import * as angular from 'angular';

import { WidgetBase, IWidgetConfiguration } from '../models';
import { Helper } from '../../common';
import { IExportToCsvService } from '../../services';
import { BadValuesTableWidgetDefinition as definition } from './badValuesTable.definition';

export class BadValuesTableWidget extends WidgetBase {
    baseType = definition.baseType;
    col = 0;
    guid: string;
    highlights = definition.highlights;
    icon = definition.icon;
    isExportable = true;
    name = definition.title;
    row = 0;
    sizeX = 6;
    sizeY = 6;
    type = definition.type;

    static $inject = [
        '$q',
        'exportToCsvService'
    ];

    constructor(
        private _$q: angular.IQService,
        private _exportToCsvService: IExportToCsvService,
        config?: IWidgetConfiguration
    ) {
        super();
        this.setConfiguration(config);
        this.guid = Helper.getGuid();
    }

    exportToCsv(guid?: string): ng.IPromise<any> {
        const defered = this._$q.defer();
        try {
            this._exportToCsvService
                .getCsvBadValuesPerTag(this.name, guid)
                .then(() => {
                    defered.resolve();
                }, (reason) => {
                    defered.reject(reason);
                })
                .catch((reason) => {
                    defered.reject(reason);
                });
        } catch (e) {
            defered.reject();
        }
        return defered.promise;
    }
}